import React from "react";
import logo from "../logo.svg";
function Logo({ onToggleSidebar }) {
  return (
    <div className="navbar-logo-box">
      <a href="#" className="logo logo-dark">
        <span className="logo-sm">
          <img src={logo} alt="logo-sm-dark" height="20" />
        </span>
        <span className="logo-lg">
          <img src={logo} alt="logo-dark" height="50" />
        </span>
      </a>

      <a href="index.html" className="logo logo-light">
        <span className="logo-sm">
          <img
            src="assets/images/logo-sm.png"
            alt="logo-sm-light"
            height="20"
          />
        </span>
        <span className="logo-lg">
          <img
            src="assets/images/logo-light.png"
            alt="logo-light"
            height="18"
          />
        </span>
      </a>

      <button
        type="button"
        className="btn btn-sm top-icon sidebar-btn"
        id="sidebar-btn"
        onClick={onToggleSidebar}
      >
        <i className="mdi mdi-menu-open align-middle fs-19"></i>
      </button>
    </div>
  );
}
export default Logo;
